import { createContext } from 'react';
import { AnyObjectSchema } from 'yup';

const BraxFormContext = createContext({
    disabled: false,
    readOnly: false,
    schema: null as any as AnyObjectSchema
});

BraxFormContext.displayName = 'BraxFormContext';

export default BraxFormContext;
